import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

const Footer = () => (
  <footer data-testid="site-footer" className="relative overflow-hidden bg-forest text-bone">
    <div className="mx-auto max-w-7xl px-6 pt-24 lg:px-10">
      <div className="grid grid-cols-1 gap-16 pb-24 md:grid-cols-3">
        <div>
          <p className="text-sm uppercase tracking-[0.2em] text-sage">Società commerciale</p>
          <p className="mt-6 max-w-xs text-bone/70 leading-relaxed">
            COMMPAQ commercializza i prodotti Propaq — piatti pronti gluten free di Michelchef srl —
            e sviluppa Risorice, il franchising di ristoranti automatizzati 100% gluten-free.
          </p>
        </div>
        <div>
          <p className="text-sm uppercase tracking-[0.2em] text-sage">Esplora</p>
          <ul className="mt-6 space-y-4">
            {[
              { to: "/propaq", label: "Prodotti Propaq", testId: "footer-propaq-link" },
              { to: "/catalogo", label: "Catalogo B2B", testId: "footer-catalogo-link" },
              { to: "/risorice", label: "Franchising Risorice", testId: "footer-risorice-link" },
              { to: "/affiliazione", label: "Candidati come affiliato", testId: "footer-affiliazione-link" },
              { to: "/simulatore", label: "Simulatore investimento", testId: "footer-simulatore-link" },
              { to: "/contatti", label: "Contatti", testId: "footer-contatti-link" },
            ].map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  data-testid={l.testId}
                  className="group inline-flex items-center gap-2 text-lg text-bone/80 transition-colors duration-300 hover:text-ochre"
                >
                  {l.label}
                  <ArrowUpRight
                    size={18}
                    className="transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5"
                  />
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div>
          <p className="text-sm uppercase tracking-[0.2em] text-sage">Contatti</p>
          <a
            href="mailto:info@commpaq.it"
            data-testid="footer-email-link"
            className="mt-6 block text-lg text-bone/80 transition-colors duration-300 hover:text-ochre"
          >
            info@commpaq.it
          </a>
          <a
            href="https://www.piattiprontiglutenfree.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-propaq-site-link"
            className="mt-3 block text-bone/50 transition-colors duration-300 hover:text-ochre"
          >
            www.piattiprontiglutenfree.com
          </a>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-bone/40 transition-colors duration-300 hover:text-ochre"
          >
            Area Riservata
          </Link>
        </div>
      </div>
    </div>

    <div className="border-t border-bone/10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-3 px-6 py-8 text-xs uppercase tracking-[0.2em] text-bone/40 sm:flex-row lg:px-10">
        <span data-testid="footer-copyright">© {new Date().getFullYear()} COMMPAQ</span>
        <span>Propaq è un marchio di Michelchef srl</span>
      </div>
    </div>
  </footer>
);

export default Footer;
